import type { FieldValues } from "react-hook-form";
import { Controller } from "react-hook-form";
import { InfoEdit } from "../editDialog/InfoEdit";
import type { FormComponentProps } from "./FormComponentProps";

interface FormInfoEditProps<TFieldValues extends FieldValues = FieldValues> extends FormComponentProps<TFieldValues> {
  minRows?: number;
}

function FormInfoEdit<TFieldValues extends FieldValues = FieldValues>({
  label,
  name,
  control,
  minRows,
  disabled,
}: FormInfoEditProps<TFieldValues>) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value } }) => (
        <InfoEdit label={label} minRows={minRows} value={value} onChange={onChange} disabled={disabled} />
      )}
    />
  );
}

export default FormInfoEdit;
